import React from 'react';
import factorySvgIcon from './utils/factorySvgIcon';
const SvgCreditCard = (props) => {
    const { color } = props;
    return (React.createElement("path", { d: "M19 4a3 3 0 013 3v10a3 3 0 01-3 3H5a3 3 0 01-3-3V7a3 3 0 013-3zm1 7H4v6a1 1 0 00.883.993L5 18h14a1 1 0 001-1v-6zm-10 3a1 1 0 01.117 1.993L10 16H6a1 1 0 01-.117-1.993L6 14h4zm9-8H5a1 1 0 00-1 1v2h16V7a1 1 0 00-.883-.993L19 6z", fill: color, fillRule: "evenodd" }));
};
export default factorySvgIcon(SvgCreditCard);
//# sourceMappingURL=SvgCreditCard.js.map